const validateChildComponent = (kind, answer) => {
  switch (kind) {
    case 'Text':
      return (answer ? !!answer.trim() : false);
    default:
      throw new Error(`Unexpected kyc child component kind '${kind}'`);
  }
};

export const validateQuestion = (kind, answer, childComponentEnabledOn, childComponentKind, childComponentAnswer) => {
  switch (kind) {
    case 'Text': {
      return (answer ? !!answer.trim() : false);
    }
    case 'Radio': {
      if (childComponentKind) {
        const isChildComponentVisible = (childComponentEnabledOn && childComponentEnabledOn.includes(answer));
        if (isChildComponentVisible) {
          return validateChildComponent(childComponentKind, childComponentAnswer);
        }
      }
      return (answer ? !!answer.trim() : false);
    }
    default:
      throw new Error(`Unexpected kyc question kind '${kind}'`);
  }
};

export const getValidQuestions = (questions) => questions.reduce((acc, question) => {
  const { kind, answer, childComponent } = question;
  const { kind: childComponentKind, enabledOn, answer: childComponentAnswer } = childComponent || {};
  const isValid = validateQuestion(kind, answer, enabledOn, childComponentKind, childComponentAnswer);
  if (isValid) return [...acc, question.id];
  return acc;
}, []);

export const createAnswerList = (questions) => questions.reduce((acc, question) => {
  const { id, answer, childComponent } = question;
  const { answer: childComponentAnswer } = childComponent || {};

  return [...acc, {
    questionId: id,
    answer,
    childComponentAnswer,
  }];
}, []);
